export const validateCompanyUser = (userData) => {
    const errors = {};
  
    if (!userData.coLicenseKey?.trim()) {
      errors.coLicenseKey = "User Name is required.";
    }
  
    if (!userData.cpPassword) {
      errors.cpPassword = "Password is required.";
    } else if (userData.cpPassword.length < 6) {
      errors.cpPassword = "Password must be at least 6 characters.";
    }
  
    return errors;
  };
  
  export const validateBranchUser = (userData) => {
    const errors = {};
  
    if (!userData.userMaster.userCode?.trim()) {
      errors.userCode = "User Code is required.";
    }
  
    if (!userData.userMaster.userPassword) {
      errors.userPassword = "User Password is required.";
    } else if (userData.userMaster.userPassword.length < 6) {
      errors.userPassword = "User Password must be at least 6 characters.";
    }
  
    if (!userData.branchInfo.brNameEng || userData.branchInfo.brNameEng === "-") {
      errors.brNameEng = "Branch Name is required.";
    }
  
    return errors;
  };
  // src/Users/validations.jsx
export const validateCompanyReg = (userData) => {
  const errors = {};

  // Validate Company Name (English)
  if (!userData.companyNameEng?.trim()) {
      errors.companyNameEng = "Company Name (English) is required.";
  }

  // Validate Company Name (Arabic)
  if (!userData.companyNameAr?.trim()) {
      errors.companyNameAr = "Company Name (Arabic) is required.";
  }

  // Validate License Key
  if (!userData.coLicenseKey?.trim()) {
      errors.coLicenseKey = "License Key is required.";
  }

  // Validate Password
  if (!userData.cpPassword) {
      errors.cpPassword = "Password is required.";
  } else if (userData.cpPassword.length < 6) {
      errors.cpPassword = "Password must be at least 6 characters.";
  }

  // Validate Registered OTP Number
  if (!userData.registeredOtpNumber?.trim()) {
      errors.registeredOtpNumber = "Registered OTP Number is required.";
  }

  // Validate Registered Email
  if (!userData.registeredEmail?.trim()) {
      errors.registeredEmail = "Registered Email is required.";
  } else if (!/\S+@\S+\.\S+/.test(userData.registeredEmail)) {
      errors.registeredEmail = "Email address is invalid.";
  }

  // Validate Billing Card Number
  if (!userData.billingCardNo?.trim()) {
      errors.billingCardNo = "Billing Card Number is required.";
  }

  // Validate Billing Card Expiry Month
  if (!userData.billingCardExpMm) {
      errors.billingCardExpMm = "Billing Card Expiry Month is required.";
  }

  // Validate Billing Card Expiry Year
  if (!userData.billingCardExpYy) {
      errors.billingCardExpYy = "Billing Card Expiry Year is required.";
  }

  // Validate Billing Card Name
  if (!userData.billingCardName?.trim()) {
      errors.billingCardName = "Billing Card Name is required.";
  }

  // Validate Billing CVV
  if (!userData.billingCvv) {
      errors.billingCvv = "Billing CVV is required.";
  }

  // Validate Agreement Terms Document URL
  if (!userData.agreementTermsDocUrl?.trim()) {
      errors.agreementTermsDocUrl = "Agreement Terms Document URL is required.";
  }

  // Validate License Start Date
  if (!userData.licenseStartDate) {
      errors.licenseStartDate = "License Start Date is required.";
  }

  // Validate Last Renewal Start Date
  if (!userData.lastRenewalStartDate) {
      errors.lastRenewalStartDate = "Last Renewal Start Date is required.";
  }

  // Validate Last Renewal End Date
  if (!userData.lastRenewalEndDate) {
      errors.lastRenewalEndDate = "Last Renewal End Date is required.";
  }

  // Validate Current Charges Monthly
  if (!userData.currentChargesMonthly) {
      errors.currentChargesMonthly = "Current Charges Monthly is required.";
  } else if (userData.currentChargesMonthly <= 0) {
      errors.currentChargesMonthly = "Current Charges Monthly must be greater than 0.";
  }

  return errors;
};